import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./login.module.css";
import { ThemeContext } from "../../context/ThemeContext";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { isDarkMode } = useContext(ThemeContext);
  const [theme, setTheme] = useState(isDarkMode);

  const handleSubmit = async () => {
    try {
      // Use Firebase authentication directly (replaces manual API call + localStorage)
      await signInWithEmailAndPassword(auth, email, password);
      
      // Wait for a small delay to ensure session is fully persisted
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Navigate to home page - ProtectedRoute will handle final verification
      navigate("/");
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error("Login error:", error);
      }
      
      // Show user-friendly error message
      let errorMessage = "Login failed. Please try again.";
      if (error.code === 'auth/invalid-credential') {
        errorMessage = "Invalid email or password.";
      } else if (error.code === 'auth/user-not-found') {
        errorMessage = "No account found with this email.";
      } else if (error.code === 'auth/wrong-password') {
        errorMessage = "Incorrect password.";
      } else if (error.code === 'auth/too-many-requests') {
        errorMessage = "Too many failed attempts. Please try again later.";
      }
      
      alert(errorMessage);
    }
  };

  useEffect(() => {
    setTheme(isDarkMode);
  }, [isDarkMode]);

  return (
    <div
      className={`${styles["login-form--container"]} ${
        theme ? styles.dark : styles.light
      }`}
    >
      <div className={styles["login-form"]}>
        <div className={styles.centeredContainer}>
          <h2 className={styles.centeredText} style={{ paddingLeft: "0px" }}>
            LOGIN
          </h2>
        </div>

        <input
          className={styles.inputbox}
          type="email"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className={styles.inputbox}
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          className={styles.button}
          onClick={() => handleSubmit(auth, email, password)}
        >
          Login
        </button>
        <p>
          Don't have an account? <Link to="/signup">Sign Up</Link>
        </p>
      </div>
    </div>
  );
}
